module.exports = __webpack_public_path__ + "assets/img/riderTip.24cbcc1b.3576e199.png";